import * as React from 'react'
import { Link } from 'react-router-dom'
import { Helmet } from 'react-helmet'
import styled from 'styled-components'
import { StoreProps } from 'src/stores'
import { StartBtn } from 'src/components/atoms/input/buttons'
import { media } from '../utils'

const background = require('src/assets/redesign/header-bg.jpg')
const bird = require('src/assets/redesign/benu_bird.png')

interface Props extends StoreProps {
  location: any
}

export default class Screen404 extends React.Component<Props, any> {
  render() {
    const { location } = this.props
    const metaTitle = '404 | Benu'
    const metaDesc =
      'Planen und beauftragen Sie eine Bestattung online in vertrauter Umgebung. ✓ Alle Bestattungsarten ✓ In ganz Österreich ✓ Persönliche Beratung ✓ Faire & Transparente Preise ▻ jetzt transparentes Angebot online gestalten!'
    const metaUrl = `https://www.benu.at${location.pathname}`
    const metaImg = 'http://dev.benu.at/benu_logo.png'

    return (
      <div>
        <Helmet>
          <meta charSet='utf-8' />
          <title>{metaTitle}</title>
          <link rel='canonical' href={metaUrl} />

          <meta name='description' content={metaDesc} />
          <meta property='og:title' content={metaTitle} />
          <meta property='og:description' content={metaDesc} />
          <meta property='og:url' content={metaUrl} />
          <meta property='og:type' content='article' />
          <meta property='og:image' content={metaImg} />

          <meta name='author' content='Benu GmbH' />
          <meta name='robots' content='noindex, nofollow' />
          <meta name='twitter:card' content={metaImg} />
          <meta name='twitter:site' content='@benu.at' />
          <meta name='twitter:creator' content='@benu.at' />
          <meta name='twitter:title' content={metaTitle} />
          <meta name='twitter:description' content={metaDesc} />
          <meta name='twitter:image' content={metaImg} />
        </Helmet>
        <Container>
          <h1>
            4 <img src={bird} alt='O' /> 4
          </h1>
          <p>
            Das tut uns leid. Diese Seite konnten wir leider nicht finden.
            <br />
            Kehren Sie einfach zu unserer Startseite zurück.
          </p>
          <Link to='/' target='_self'>
            <StartBtn>Startseite</StartBtn>
          </Link>
          <p>
            Haben Sie eine Frage an uns?
            <br />
            Rufen Sie uns einfach an. Wir sind 24h für Sie da.
            <br />
            <strong>01 907 68 85</strong>
          </p>
        </Container>
      </div>
    )
  }
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100vh;
  min-height: 680px;
  padding-top: 80px;
  background-image: url(${background});
  background-size: cover;
  background-position: center;

  & > * {
    margin: 15px;
  }

  h1 {
    font-weight: 100;
    font-size: 95px;
    color: #111;
    img {
      vertical-align: text-bottom;
    }
  }

  p {
    font-size: 25px;
    text-align: center;
  }

  ${media.desktop` p { font-size: 22px; } `}
  ${media.tablet`
    padding-top: 20;
    h1 { font-size: 85px; }
    p { font-size: 20px; }
  `}
`



// WEBPACK FOOTER //
// ./src/screens/Screen404.tsx